import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from '@chakra-ui/react';
import React from 'react';

import { PopoverComponentProps } from './interfaces';

const PopoverComponent: React.FC<PopoverComponentProps> = ({
  title,
  body,
  trigger,
  styles,
  placement = 'bottom-start',
  children,
  disabled = false,
}) => {
  return (
    <Popover
      placement={placement}
      offset={[20, 8]}
      preventOverflow
      isLazy
      trigger="hover"
      lazyBehavior="keepMounted"
      {...styles?.popover}
    >
      <PopoverTrigger>{trigger}</PopoverTrigger>

      {!disabled && (children || body) && (
        <PopoverContent
          maxWidth="400"
          width="400"
          bgColor="#333"
          color="#FFF"
          border="none"
        >
          <PopoverArrow
            bgColor="#333"
            color="#FFF"
            style={{
              '--popper-arrow-shadow-color': 'transparent',
            }}
          />
          {title && (
            <PopoverHeader fontWeight={700} bgColor="#333" color="#FFF">
              {title}
            </PopoverHeader>
          )}
          <PopoverBody
            paddingBottom={2}
            overflow="hidden"
            bgColor="#333"
            color="#FFF"
            border="none"
            borderRadius={3}
          >
            {children || body}
          </PopoverBody>
        </PopoverContent>
      )}
    </Popover>
  );
};

export default PopoverComponent;
